module.exports = __webpack_public_path__ + "img/shirt_2_big.b17aaad9.jpg";